import React from "react";
import { useEffect, useState, useRef } from "react";
import { useNavigate , useLocation} from "react-router-dom";
import "./Home.scss";
import {
  getWheel,
  spinWheel,
  getWheelInfo,
  getUIConfig,
  spinWheelResult,
} from "../../../config/services/spinService";
import { imageKeyMappings } from "../../../assets/images/imageKeyMappings";
import TncViewer from "../../shared/tnc-viewer/TncViewer";
import PubSub from "pubsub-js";
import {
  GET_PROFILE,
  UPDATE_PROFILE,
} from "../../../config/services/profileService";
import { APILOG } from "../../../config/services/Analytics";
import { eventTrack } from "../../../config/utils/GaTags";
function Home() {
  const [tncChecked, setTncChecked] = useState(false);
  const [showTncReader, setShowTncReader] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [profile, setProfile] = useState(null);
  const [prizesData, setPrizesData] = useState(null);
  const [uiConfig, setUiConfig] = useState(null);
  const [prizeData, setPrizeData] = useState(null);
  const [isSpinNow, setSpinNowStatus] = useState(false);
  const navigate = useNavigate();
  const [wheelRotation, setWheelRotation] = useState(0);
  const wheelRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [spinInfo, setSpinInfo] = useState("");
  const [spinExhaust, setSpinExhaust] = useState(false);
  const [prizeQuadrant, setPrizeQuadrant] = useState(0);
  const location = useLocation();
  const utmParams = location?.state?.utmParams || {};



  useEffect(() => {
    setLoading(false);
    getWheelData();
    getProfile();
    getSpinInfo();
    const tncClose = PubSub.subscribe("tncClose", toggleTncPopup);
    return () => {
      PubSub.unsubscribe(tncClose);
    };
  }, []);

  useEffect(() => {
    if (profile && !mounted) {
      handleGA(profile);
      setMounted(true);
    }
  }, [profile, mounted]);

  const getProfile = async () => {
    try {
      const response = await GET_PROFILE();
      setProfile(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setPrizeData({ success: false });
      navigate("/fallback", { state: { error: error.message } });
    }
  };

  function handleGA(data) {
    if (data && !data?.TnC) {
      eventTrack("pageload", "first_visit_page");
      APILOG("first_visit_page", "pageload");
    } else {
      eventTrack("pageload", "home_page");
      APILOG("home_page", "pageload");
    }
  }

  const updateProfile = async () => {
    let payload = {
      TnC: true,
    };
    try {
      const response = await UPDATE_PROFILE(payload);
      getProfile();
    } catch (error) {
      console.error("Error fetching data:", error);
      navigate("/fallback", { state: { error: error.message } });

      setPrizeData({ success: false });
    }
  };
 
  const getWheelData = async () => {
    try {
      const response = await getWheel();
      if(response){
        const sortedPrizes = response.prizes.sort((a, b) => a.seqNo - b.seqNo);
        response.prizes = sortedPrizes;
        setPrizesData(response);
        response?.prizes.forEach((prize, index) => {
          document.documentElement.style.setProperty(`--quadTopColor-${index + 1}`, prize?.quadTopColor);
          document.documentElement.style.setProperty(`--quadBottomColor-${index + 1}`, prize?.quadBottomColor);
        });
      }
      const uiC = await getUIConfig(response?.uiConfigId); // needs testing
      setUiConfig(uiC);
      setLoading(false);

    } catch (error) {
      console.error("Error fetching data:", error);
      setPrizeData({ success: false });
      navigate("/fallback", { state: { error: error.message } });
    }
  };

  const getPrizeClass = () => {
    const length = prizesData?.prizes.length;
    document.documentElement.style.setProperty('--num-segments', prizesData?.prizes.length);
    
    return `prize-container-${length}`; // Generates classes like 'home-page-5' or 'home-page-8'
  };
 
  const getSpinInfo = async () => {
    try {
      const response = await getWheelInfo();
      setSpinInfo(response);
      if (response.prize && response.prize.type!="BLNT") {
        navigate("/result", { state: { prizes: response, uiConfig: uiConfig } });
      }
    } catch (error) {
      if (error.response.data.customCode) {
        setSpinExhaust(true);
      } else {
        navigate("/fallback", { state: { error: error.message } });
      }
    }
  };

  const spinWheel = async (quadrantId, totalQuadrants, response) => {
    const baseDegrees = {
      4: [3645, 3555, 3465, 3375],
      5: [3666, 3594, 3522, 3450, 3378],
      6: [3670, 3614, 3552, 3493, 3430, 3375],
      7: [3665, 3610, 3563, 3510, 3460, 3408, 3355],
      8: [3660, 3620, 3580, 3530, 3490, 3445, 3400, 3355],
    };
  
    const degrees = baseDegrees[totalQuadrants];
    if (!degrees || !degrees[quadrantId - 1]) {
      console.error("Invalid quadrantId or totalQuadrants");
      return;
    }
  
    const deg = degrees[quadrantId - 1];
  
    // Adjust to zero position
    let maketoZero = 0;
    if (wheelRotation > 0) {
      const remainder = wheelRotation % 360;
      const completeTurns = Math.ceil(wheelRotation / 360);
      maketoZero = completeTurns * 360 - wheelRotation;
    }
  
    const newRotation = wheelRotation + deg + maketoZero;
    setWheelRotation(newRotation);
  
    if (wheelRef.current) {
      wheelRef.current.style.transform = `rotate(${newRotation}deg)`;
    }
  
    // Handle spin result
    const spinTimeout = setTimeout(() => {
      setPrizeQuadrant(response?.prize?.seqNo);
      navigateToResult(response);
      clearTimeout(spinTimeout);
    }, 10000);
  };
  
  const spinWheelNow = async () => {
    try {

      const response = await spinWheelResult();
      setPrizeData(response);
      
      APILOG("reward_page", "gratification",{...utmParams,
        coupon_name: response?.prize?.type === "BLNT" ? "BLNT": response?.prize?.name,
        coupon_id: response?.prize?.id,
        wheel_id: response?.wheelID,
        attempt: spinInfo?.totalSpins - (spinInfo?.spinsLeft-1)
      })
  
      const index = prizesData?.prizes.findIndex(
        (item) => item?.seqNo === response?.prize?.seqNo
      );
      const quadrantId = index + 1;
      const totalQuadrants = prizesData?.prizes?.length;
  
      if (totalQuadrants >= 4 && totalQuadrants <= 8) {

        await spinWheel(quadrantId, totalQuadrants, response);
      } else {
        console.error("Unsupported number of quadrants");
      }
    } catch (error) {
      navigate("/fallback", { state: { error: error.message } });
      setPrizeData({ success: false });
    }
  };

  const navigateToResult = (data) => {
    setTimeout(() => {
      navigate("/result", { state: { prizes: data, uiConfig: uiConfig } });
    }, 1500);
  };

  const handleTncAccept = () => {
    setTncChecked(!tncChecked);
  };

  const toggleTncPopup = () => {
    setShowTncReader((prevState) => !prevState);
    if (showTncReader) {
      eventTrack("read_tnc", "first_visit_page");
      eventTrack("pageload", "tnc_popup");
    }
  };

  const proceedSpin = async () => {
    setPrizeQuadrant(0);
    if (isSpinNow) {
      return;
    }
    if (profile && !profile?.TnC) {
      console.log(spinInfo)
      eventTrack("proceed", "first_visit_page");
      APILOG("first_visit_page", "dial_now", {wheel_id:prizesData?.wheelID , attempt: spinInfo?.totalSpins - (spinInfo?.spinsLeft-1)});
    } else {
      eventTrack("proceed", "home_page", { match: spinInfo?.spinsLeft });
      APILOG("home_page", "dial_now", {wheel_id:prizesData?.wheelID ,attempt: spinInfo?.totalSpins - (spinInfo?.spinsLeft-1)});
    }
    if (profile && !profile?.TnC) {
      updateProfile();
    }

    setTimeout(() => {
      setSpinNowStatus(true);
    }, 100);
    spinWheelNow();
  };


  const navigateTo = (data) => {
    switch (data) {
      case "vouchers":
        APILOG("reward_page", "my_vouchers");
        eventTrack("select_option", "home_page", {
          event_action: "my_vouchers",
        });
        if (process.env.REACT_APP_ENVIRONMENT == "dev") {
          window.location.href = `https://jioplayalong4.akamaized.net/tiramywinning/index.html?userId=${profile?.userId}&platform=tirabeauty&engagement=spin2win`;
        } else {
          window.location.href = `https://jioplayalong5.akamaized.net/tiramywinning/index.html?userId=${profile?.userId}&platform=tirabeauty&engagement=spin2win`;
        }
        console.log("Navigate to My Vouchers");
        break;
    }
  };

  return (
    <React.Fragment>
      {!loading ? (
        <div
          className="home-page"
          style={{
            backgroundImage: uiConfig?.backgroundImage
              ? `url(${uiConfig?.backgroundImage})`
              : "none",
          }}
        >
          <div className="container">
            <div className="top-block">
              <div className="heading">{uiConfig?.homepageTitleText}</div>
              <div className="sub-text">{uiConfig?.homepageSubTitleText}</div>
            </div>

            <div className="spin-wheel">
              <div className="wheel-container">
                <div className="marker-wrapper">
                  <img className="marker" src={uiConfig?.SpinWheelMarker}></img>
                </div>
                <div className="wheel-content" ref={wheelRef}>
                  <div className=" wheel wheel-circle">
                    {prizesData?.prizes.map((item, index) => (
                      <div className={getPrizeClass()} key={index}>
                        <div className="prize">
                          {item?.name ? item?.name : item?.title}
                        </div>
                        <div className="desc-container">
                          <img
                            className={
                              item?.isBrandLogo ? "logo brand-logo" : "logo"
                            }
                            src={item?.imgurl}
                          />
                        </div>
                            <div className="last-segment-overlay">
                              <div className="last-segment-overlay-content">
                              </div>
                            </div>
                        {Boolean(prizeQuadrant) && (
                          <div
                            className={
                              prizeQuadrant !== item?.seqNo
                                ? " prize-overlay"
                                : null
                            }
                          ></div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-block">
            {profile && !profile?.TnC ? (
              <div className="tnc-block">
                <div className="checkbox" onClick={handleTncAccept}>
                  <img
                    src={
                      tncChecked
                        ? imageKeyMappings?.tncChecked
                        : imageKeyMappings?.tncUnchecked
                    }
                  />
                </div>
                <div className="tnc-text">
                  Click here to
                  <br />
                  1) Agree to our{" "}
                  <span onClick={toggleTncPopup}>Terms & Conditions </span> and;
                  <br />
                  2) Confirm that you are not accessing this from Tamil Nadu
                </div>
              </div>
            ) : null}
            {profile && profile?.TnC && !spinExhaust && profile?.userId && (
              <div className="attempts-left">
                {" "}
                You have{" "}
                <span>
                  {spinInfo?.spinsLeft}/{spinInfo?.totalSpins}
                </span>{" "}
                attempts left
              </div>
            )}
            {spinExhaust && (
              <div className="max-attempt">
                You've maxed out on your attempts for the day.
                <br />
                Please try again tomorrow!
              </div>
            )}
            <div className="cta-block">
              <div
                className={
                  (!tncChecked && !profile?.TnC) || isSpinNow || spinExhaust
                    ? "disabled"
                    : "spin-cta"
                }
                onClick={proceedSpin}
              >
                {uiConfig?.spinNowCtaText}
              </div>

              {profile && profile?.userId && profile?.TnC && (
                <div
                  className="my-vouchers"
                  onClick={() => navigateTo("vouchers")}
                >
                  My Vouchers
                </div>
              )}
            </div>
          </div>

          {showTncReader ? (
            <TncViewer tncUrl={prizesData?.tncUrl}></TncViewer>
          ) : null}
        </div>
      ) : (
        <div className="loader-page">
          <span className="loader"></span>
        </div>
      )}
    </React.Fragment>
  );
}

export default Home;
